document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.faq-item').forEach(item => {
    const button = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    if (!button || !answer) return;

    button.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');

      // Cerrar los demás (opcional)
      document.querySelectorAll('.faq-item.is-open').forEach(openItem => {
        if (openItem !== item) closeItem(openItem);
      });

      isOpen ? closeItem(item) : openItem(item);
    });
  });

  function openItem(el) {
    const answer = el.querySelector('.faq-answer');
    const button = el.querySelector('.faq-question');
    el.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    answer.setAttribute('aria-hidden', 'false');
    answer.style.height = answer.scrollHeight + 'px';
  }

  function closeItem(el) {
    const answer = el.querySelector('.faq-answer');
    const button = el.querySelector('.faq-question');
    el.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');
    answer.setAttribute('aria-hidden', 'true');
    answer.style.height = 0;
  }
});